module.exports = __webpack_public_path__ + "img/data-statistics.5719d8f1.svg";